import React from "react";
import { mergeKpiConfigs } from "../config";
import InfoTitle from "./InfoTitle";

const KpiPrefix = ({ prefix, prefixConfig, option }) => {
  ({ prefixConfig } = mergeKpiConfigs(option, {
    prefixConfig,
  }));
  return (
    <div>
      <InfoTitle title={prefix} {...prefixConfig} />
    </div>
  );
};

export default KpiPrefix;
